
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syntax-guide",
      function () {
        return require("private-next-pages/syntax-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syntax-guide"])
      });
    }
  